// extracted by mini-css-extract-plugin
module.exports = {"resend":"ResendMessage_resend__2aYVz","resend__action":"ResendMessage_resend__action__3o2Rk","resend__link":"ResendMessage_resend__link__1DGY2"};